import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { GridApi, GridOptions } from 'ag-grid-community'

import { FlxThemeModule } from '@flowx/angular-theme'
import { FlxTableComponent } from '@flowx/angular-ui-toolkit'
import { DEFAULT_PAGE_SIZE, TABLE_PAGE_SIZE_SELECTOR } from '@flowx/core-sdk'

const defaultGridOptions: GridOptions = {
  rowModelType: 'clientSide',
  suppressCellFocus: true,
  paginationPageSize: DEFAULT_PAGE_SIZE,
  pagination: true,
  paginationPageSizeSelector: TABLE_PAGE_SIZE_SELECTOR,
  rowSelection: {
    mode: 'multiRow',
    headerCheckbox: true,
    checkboxes: true,
    selectAll: 'currentPage',
  },
}

@Component({
  selector: 'flx-tasks-grid',
  imports: [FlxTableComponent, FlxThemeModule],
  templateUrl: './flx-tasks-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './flx-tasks-grid.component.scss',
})
export class FlxTasksGridComponent {
  gridOptions = input<GridOptions>()
  computedGridOptions = computed(() => {
    const hideRowSelection = this.gridOptions()?.rowSelection === null
    const columnDefs =
      hideRowSelection && this.gridOptions()?.columnDefs
        ? this.gridOptions()?.columnDefs || []
        : [{ width: 50, sortable: false }, ...(this.gridOptions()?.columnDefs || [])] // add extra space for row selection checkbox
    const gridOptions = this.gridOptions()
      ? { ...defaultGridOptions, ...this.gridOptions(), columnDefs }
      : null

    return gridOptions
  })
  gridReady = output<GridApi>()

  emitGridApi(api: GridApi): void {
    this.gridReady.emit(api)
  }
}
